/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react'
import { toAbsoluteUrl } from '../../../_metronic/helpers'
type Props = {
  className: string
}

const TwoItemRow = ({heading,data}:{heading:any,data:any}) => {
  
 


  return (
    <div className="w-100">
        <label className='fontsize22px fw-bold'>{heading}</label>
        <div className="row w-100">
            {
                data.map((item:any,index:any)=>{
                    return(<>
                        <div className="col-lg-6 col-xl-6">
                            
                            <div className="w-100 d-flex align-items-center p-5 rounded my-2 maxwidth95 bgF5F5F5">
                                <div className="symbol symbol-75px me-2">
                                    <span className="symbol-label">
                                        <img src="/fox/uztrip/admin/static/media/hotel2.90f354de51ae853a76a35326db3fb6a7.svg" className="h-100 align-self-center" alt="" />
                                    </span>
                                </div>
                                <div className='w-100 d-flex align-items-center justify-content-between'>
                                    
                                    <div className="div marginleft20px">
                                        <label className='w-100 fw-bold text-hover-primary mb-1 fontsize16px themeBlueColor'>Agra</label>
                                        <label className='text-muted fw-semibold d-block fontsize14px pt-2'><img src={toAbsoluteUrl("/media/Map Point.png")} /> India</label>


                                    </div>
                                    <a href="#" className="btn btn-sm btn-icon btn-active-color-primary">
                                        <img src={toAbsoluteUrl("/media/otherSVG/rightArrow.svg")} />
                                    
                                    </a>
                                </div>
                            </div>
                        </div>                    
                    </>)
                })
            }
        </div>

    </div>
  )
}

export {TwoItemRow}


